/* eslint-disable */

import axios from "axios";
import queryString from "query-string";
import $ from "jquery";

const AssessorSearch = () => {
  // Global constants
  const searchForm = document.querySelector(".assessor-search-form");

  const fetchResults = params => {
    // Fetch our results

    // Set our browser URL
    const windowUrl = `${window.location.origin}${
      window.location.pathname
    }?${queryString.stringify(params)}`;
    window.history.pushState(params, null, windowUrl);

    // Fire off our request
    const url = searchForm.action;
    axios
      .get(url, {
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Content-Type": "multipart/form-data"
        },
        params
      })
      .then(response => {
        // console.log(response.data);
        // Set the html to our returned response
        const container = document.querySelector(".assessor-results");
        container.innerHTML = response.data;
      })
      .catch(error => {
        console.warn(error);
      });
  };
};

var select = $('.filterable-search-select select');
var selectOption = $('.filterable-search-select select option');

if (select.attr('data-type')) {
  selectOption.each(function () {
    var optionValue = $(this).val();
    if(optionValue == select.attr('data-type')) {
      $(this).prop('selected', true);
    }
  });
}

export default AssessorSearch;

/* eslint-enable */
